export const MODULE_UPLOAD = {
  MATERIALITY_ASSESSMENT: 'MATERIALITY_ASSESSMENT',
  SOX_PROCESS: 'SOX_PROCESS',
  ENTITY_SCOPING: 'ENTITY_SCOPING',
  CHARGEBEE_SOF: 'CHARGEBEE_SOF',
  CONTROL_WORDING: 'CONTROL_WORDING',
  EVIDENCE_MAPPING: 'EVIDENCE_MAPPING',
  // RCM bulk upload: spreadsheet drives risks + controls + process_risk_controls
  // via /api/rcm-upload/{validate,import}. Distinct module so the file gets
  // routed under its own storage path instead of CONTROL_WORDING.
  RCM: 'RCM',
} as const;

export type ModuleUpload = (typeof MODULE_UPLOAD)[keyof typeof MODULE_UPLOAD];

export const MODULE_UPLOAD_VALUES: ModuleUpload[] = Object.values(MODULE_UPLOAD);

export const isModuleUpload = (value: string): value is ModuleUpload => {
  return MODULE_UPLOAD_VALUES.includes(value as ModuleUpload);
};